import { useRef, useState } from "react";
import { useMutation } from "@apollo/client/react";
import { useIntl } from "react-intl";
import { RequestListingApplicationPowerQuizDocument } from "@/graphql/generated/operations";
import { userErrorMessage } from "@/lib/user-error";

export function useRequestPowerQuiz(applicationId: string) {
  const intl = useIntl();
  const attempt = useRef<string | null>(null);
  const busy = useRef(false);
  const [request, { loading }] = useMutation(RequestListingApplicationPowerQuizDocument);
  const [error, setError] = useState<string | null>(null);
  async function send() {
    if (busy.current) return;
    busy.current = true;
    setError(null);
    attempt.current ??= crypto.randomUUID();
    try {
      const result = await request({ variables: { input: { id: applicationId, requestId: attempt.current } } });
      if (!result.data?.requestListingApplicationPowerQuiz) throw new Error("Missing quiz request outcome");
      attempt.current = null;
    } catch (e) { setError(userErrorMessage(intl, e)); }
    finally { busy.current = false; }
  }
  return { send, loading, error };
}
